var popoverThemeWeb = {
  background: 'secondary'
};
export { popoverThemeWeb };